import $ from 'jquery';

const video = $('#jc-vid')[0];
const toggle = $('.is-playing');

function togglePlay(event) {
	event.preventDefault();
	const isPlaying = video.paused ? 'play' : 'pause';
	video[isPlaying]();
	toggle.toggleClass("is-playing")
}

if (video) {
	toggle.on('click', togglePlay);
}